"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var string_1 = require("./utils/string");
function processChange(maskOptions, value, selection, previousValue, previousSelection) {
    var mask = maskOptions.mask, prefix = maskOptions.prefix, lastEditablePosition = maskOptions.lastEditablePosition;
    var newValue = value;
    var enteredString = "";
    var formattedEnteredStringLength = 0;
    var removedLength = 0;
    var cursorPosition = Math.min(previousSelection.start, selection.start);
    if (selection.end > previousSelection.start) {
        enteredString = newValue.slice(previousSelection.start, selection.end);
        formattedEnteredStringLength = string_1.getInsertStringLength(maskOptions, previousValue, enteredString, cursorPosition);
        if (!formattedEnteredStringLength) {
            removedLength = 0;
        }
        else {
            removedLength = previousSelection.length;
        }
    }
    else if (newValue.length < previousValue.length) {
        removedLength = previousValue.length - newValue.length;
    }
    newValue = previousValue;
    if (removedLength) {
        if (removedLength === 1 && !previousSelection.length) {
            var deleteFromRight = previousSelection.start === selection.start;
            cursorPosition = deleteFromRight
                ? string_1.getRightEditablePosition(maskOptions, selection.start)
                : string_1.getLeftEditablePosition(maskOptions, selection.start);
        }
        newValue = string_1.clearRange(maskOptions, newValue, cursorPosition, removedLength);
    }
    newValue = string_1.insertString(maskOptions, newValue, enteredString, cursorPosition);
    cursorPosition = cursorPosition + formattedEnteredStringLength;
    if (cursorPosition >= mask.length) {
        cursorPosition = mask.length;
    }
    else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
        cursorPosition = prefix.length;
    }
    else if (cursorPosition >= prefix.length &&
        cursorPosition < lastEditablePosition &&
        formattedEnteredStringLength) {
        cursorPosition = string_1.getRightEditablePosition(maskOptions, cursorPosition);
    }
    newValue = string_1.formatValue(maskOptions, newValue);
    if (!enteredString) {
        enteredString = null;
    }
    return {
        value: newValue,
        enteredString: enteredString,
        selection: { start: cursorPosition, end: cursorPosition }
    };
}
exports.default = processChange;
